import { type RefObject, useLayoutEffect, useState } from 'react';

/**
 * The scale (never above 1) at which a picture drawn `natural` px wide fits
 * the element's width, less `inset` — how the tiles' pictures shrink onto a
 * phone whole, in proportion, instead of being cut.
 */
export function useFitWidth(
  ref: RefObject<HTMLElement | null>,
  natural: number,
  inset = 0,
): number {
  const [scale, setScale] = useState(1);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => {
      const width = el.clientWidth - inset;
      if (width > 0) setScale(Math.min(1, width / natural));
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, natural, inset]);
  return scale;
}
